"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mapValues = (obj, callback) => Object.entries(obj).reduce((result, [k, v]) => {
    const value = v;
    const key = k;
    result[key] = callback(value, key);
    return result;
}, {});
exports.default = mapValues;
